import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useLanguageStore from '~/helpers/store/locale/locale'
import { organizationLanguage } from '~/i18n/initial-language'

/** Applique la langue de l'organisation, tant que l'utilisateur n'a pas choisi la sienne (#146). */
export function useOrganizationLanguage(orgDefault: string | null | undefined): void {
  const { i18n } = useTranslation()
  const chosen = useLanguageStore(state => state.locale)
  useEffect(() => {
    const language = organizationLanguage(chosen, orgDefault)
    if (language && i18n.language !== language) void i18n.changeLanguage(language)
  }, [chosen, orgDefault, i18n])
}
